import { render, staticRenderFns } from "./MarketplaceBanner.vue?vue&type=template&id=d05f6650&scoped=true"
import script from "./MarketplaceBanner.vue?vue&type=script&lang=js"
export * from "./MarketplaceBanner.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceBanner.vue?vue&type=style&index=0&id=d05f6650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05f6650",
  null
  
)

export default component.exports